// src/components/Events/PreSummit.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Events.css';
import SignInModal from './SignInModal';

// Image placeholders for bottom gallery
const galleryImages = {
  climate: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600',
  rainforest: 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=600',
  solar: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=600',
  agriculture: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=600',
  train: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=600'
};

const PreSummit = () => {
  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [selectedFlier, setSelectedFlier] = useState(null);
  const [showAllSpeakers, setShowAllSpeakers] = useState(false);

  const openSignIn = () => setIsSignInOpen(true);
  const closeSignIn = () => setIsSignInOpen(false);

  const openFlierModal = (flierSrc) => {
    setSelectedFlier(flierSrc);
  };

  const closeFlierModal = () => {
    setSelectedFlier(null);
  };

  const toggleSpeakers = () => {
    setShowAllSpeakers(!showAllSpeakers);
  };

  // All speakers/presenters from the programme
  const allSpeakers = [
    // Opening Ceremony
    {
      id: 1,
      name: "H.E. Amb Dr. Dunoma Umar Ahmed, PhD",
      title: "Permanent Secretary, Federal Ministry of Foreign Affairs",
      image: "/images/speakers/permsec.png",
      status: "Chairman of the Event",
      topic: "Opening Ceremony"
    },
    {
      id: 2,
      name: "Hon. Moses O. T. Owharo",
      title: "Chairman/CEO, ABVIG & Convener, AICIS 2026",
      image: "/images/speakers/moses-owharo.jpeg",
      status: "Chairman/CEO, ABVIG & Convener",
      topic: "Opening Remarks & Overview of AICIS 2026"
    },
    {
      id: 3,
      name: "Representative, Office of the SGF",
      title: "Office of the Secretary to the Government of the Federation",
      image: "/images/speakers/SGF-diplomatic.jpg",
      status: "Speaker",
      topic: "Goodwill Message"
    },
    {
      id: 4,
      name: "H.E. Amb. Bianca Odumegwu-Ojukwu",
      title: "Honourable Minister of Foreign Affairs",
      image: "/images/speakers/bianca-ojukwu.jpg",
      status: "Keynote Speaker",
      topic: "Keynote Address"
    },
    // Session I
    {
      id: 5,
      name: "Ambassador Faruk Malami Yabo",
      title: "Permanent Secretary, Federal Ministry of Foreign Affairs",
      image: "/images/speakers/Faruk-Yabo.jpg",
      status: "Chairman - Session I",
      topic: "Diplomatic Leadership, International Cooperation & Strategic Partnerships"
    },
    {
      id: 6,
      name: "Representative, U.S. Embassy",
      title: "Embassy of the United States of America",
      image: "/images/speakers/United-States-Embassy.jpg",
      status: "Co-Chair - Session I",
      topic: "U.S.–Africa Strategic Cooperation"
    },
    {
      id: 7,
      name: "Representative, Federal Ministry of Defence",
      title: "Federal Ministry of Defence",
      image: "/images/speakers/ministry-of-defence.png",
      status: "Co-Chair - Session I",
      topic: "Diplomatic Leadership, International Cooperation & Strategic Partnerships"
    },
    {
      id: 8,
      name: "Prof. M. T. Ladan",
      title: "Chief Adviser, Diplomacy & International Relations, AICIS Planning Committee",
      image: "/images/speakers/Tawfiq-Ladan.png",
      status: "Moderator - Session I",
      topic: "Diplomatic Leadership, International Cooperation & Strategic Partnerships"
    },
    {
      id: 9,
      name: "Dean of the Diplomatic Corps",
      title: "Dean of the Diplomatic Corps",
      image: "/images/speakers/Corps-diplomatique-diplomatic-corps-emblem.png",
      status: "Presenter - Session I",
      topic: "Diplomatic Perspectives on Global Partnerships"
    },
    {
      id: 10,
      name: "European Union Delegation",
      title: "European Union Delegation",
      image: "/images/speakers/european-union.jpg",
      status: "Presenter - Session I",
      topic: "EU–Africa Investment & Climate Partnership"
    },
    {
      id: 11,
      name: "Arab Diplomatic Missions",
      title: "Arab Diplomatic Missions",
      image: "/images/speakers/arab-diplomatic.jpg",
      status: "Presenter - Session I",
      topic: "Arab–Africa Economic Cooperation"
    },
    // {
    //   id: 12,
    //   name: "Asian Diplomatic Missions",
    //   title: "Asian Diplomatic Missions",
    //   image: "/images/speakers/asian-diplomacy.jpg",
    //   status: "Presenter - Session I",
    //   topic: "Asia–Africa Infrastructure Partnerships"
    // },
    // Session II
    {
      id: 14,
      name: "Prof. Steve Azaiki",
      title: "Former Member, House of Representatives, Former Member, House Committee on Foreign Affairs",
      image: "/images/speakers/Prof-Steve-Azaiki.jpg",
      status: "Moderator - Session II",
      topic: "Government Policy, Infrastructure, Climate Action & National Development"
    },
    {
      id: 15,
      name: "Federal Ministry of Environment / NCCC",
      title: "Federal Ministry of Environment / National Council on Climate Change",
      image: "/images/speakers/nccc.jpg",
      status: "Presenter - Session II",
      topic: "Climate Governance & National Climate Policy"
    },
    {
      id: 16,
      name: "Federal Ministry of Finance",
      title: "Federal Ministry of Finance",
      image: "/images/speakers/Federal_Ministry_of_Finance.jpg",
      status: "Presenter - Session II",
      topic: "Financing Infrastructure & Climate Projects"
    },
 
    {
      id: 18,
      name: "House Committee on Climate Change",
      title: "House Committee on Climate Change",
      image: "/images/speakers/CommitteeonClimateChange.jpg",
      status: "Presenter - Session II",
      topic: "Legislative Support for Climate Action"
    },
    // Session III
    {
      id: 19,
      name: "Representative, African Development Bank",
      title: "African Development Bank",
      image: "/images/speakers/Africa_development_bank.png",
      status: "Chair - Session III",
      topic: "Development Finance, Energy Transition & Investment Mobilisation"
    },
    {
      id: 20,
      name: "Representative, Afreximbank",
      title: "African Export-Import Bank (Afreximbank)",
      image: "/images/speakers/Afreximbank.jpg",
      status: "Co-Chair - Session III",
      topic: "Trade & Infrastructure Finance"
    },
    {
      id: 21,
      name: "Representative, World Bank",
      title: "World Bank",
      image: "/images/speakers/world_bank.jpg",
      status: "Moderator - Session III",
      topic: "Building Investment-Ready Projects"
    },
 

    {
      id: 25,
      name: "Zenith Bank Plc",
      title: "Zenith Bank Plc",
      image: "/images/speakers/zenith-w-bg.jpeg",
      status: "Presenter - Session III",
      topic: "Mobilising Sustainable Finance, Green Banking & Infrastructure Investment"
    },
    {
      id: 26,
      name: "FCMB Group",
      title: "FCMB Group",
      image: "/images/speakers/fcmb.jpg",
      status: "Presenter - Session III",
      topic: "Innovative Financial Solutions for SMEs, Infrastructure Development & Climate Investment"
    },
    {
      id: 27,
      name: "Central Bank of Nigeria",
      title: "Central Bank of Nigeria",
      image: "/images/speakers/cbn-logo.jpg",
      status: "Presenter - Session III",
      topic: "Monetary Policy & Investment Stability"
    },
    // Session IV

    {
      id: 29,
      name: "Representative, UN Resident Coordinator's Office",
      title: "United Nations Resident Coordinator's Office",
      image: "/images/speakers/un-logo.jpg",
      status: "Moderator - Session IV",
      topic: "Energy Institutions, State Governments & Strategic Partnership Commitments"
    },
    {
      id: 30,
      name: "NUPRC",
      title: "Nigerian Upstream Petroleum Regulatory Commission",
      image: "/images/speakers/nuprc.jpg",
      status: "Presenter - Session IV",
      topic: "Nigeria's Upstream Investment Opportunities"
    },
    {
      id: 31,
      name: "NNPC Limited",
      title: "NNPC Limited",
      image: "/images/speakers/nnpc.jpg",
      status: "Presenter - Session IV",
      topic: "NNPC Limited Strategic Investment Agenda"
    },
    {
      id: 32,
      name: "Federal Ministry of Petroleum Resources",
      title: "Federal Ministry of Petroleum Resources",
      image: "/images/speakers/ministry_pet_resources.jpg",
      status: "Presenter - Session IV",
      topic: "Petroleum Sector Reforms & Investment"
    },
    {
      id: 33,
      name: "NCDMB",
      title: "Nigerian Content Development & Monitoring Board",
      image: "/images/speakers/ncdmb.jpg",
      status: "Presenter - Session IV",
      topic: "Local Content & Industrial Development"
    },
    {
      id: 34,
      name: "UNDP, UNICEF & UN System",
      title: "United Nations Development Programme, UNICEF & UN System",
      image: "/images/speakers/UNDP.png",
      status: "Presenter - Session IV",
      topic: "UN Support for Sustainable Development & Climate Partnerships"
    },
    {
      id: 35,
      name: "Representative, Nigeria Governors' Forum (NGF)",
      title: "Nigeria Governors' Forum",
      image: "/images/speakers/nig_govt_forumn.jpg",
      status: "Presenter - Session IV",
      topic: "State Governments as Drivers of Bankable Infrastructure, Climate Resilience & Green Investment Projects"
    },
    // Closing Ceremony
    {
      id: 37,
      name: "H.E. Amb. (Mrs.) Mobalaji S. Ogundero",
      title: "Technical Adviser – International Cooperation, Federal Ministry of Foreign Affairs",
      image: "/images/speakers/Mobalaji.jpeg",
      status: "Closing Speaker",
      topic: "Closing Remarks"
    }
  ];

  // Show only first 12 initially
  const initialSpeakers = allSpeakers.slice(0, 12);
  const displayedSpeakers = showAllSpeakers ? allSpeakers : initialSpeakers;

  return (
    <div 
      className="poster-container"
      style={{ 
        backgroundImage: 'url(/images/mofa.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* ===== BACKGROUND OVERLAY ===== */}
      <div className="poster-overlay"></div>

      {/* ===== TOP LOGOS ===== */}
      <div className="pre-summit-logos-top">
        <div className="pre-summit-logos-row">
          <div className="pre-summit-logo-item">
            <img 
              src="/images/hero/presidency.png" 
              alt="Presidency" 
              className="img-zoom"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span>Presidency</span>
          </div>
          <div className="pre-summit-logo-divider"></div>
          <div className="pre-summit-logo-item">
            <img 
              src="/images/hero/abvig-logo.jpg" 
              alt="ABVIG" 
              className="img-zoom"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span>ABVIG</span>
          </div>
          <div className="pre-summit-logo-divider"></div>
          <div className="pre-summit-logo-item">
            <img 
              src="/images/hero/foreign-affairs.jpg" 
              alt="Foreign Affairs" 
              className="img-zoom"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span>Foreign Affairs</span>
          </div>

          <div className="pre-summit-logo-divider"></div>
            <div className="pre-summit-logo-item">
              <img src="/images/hero/zenith-w-bg.jpeg" alt="Zenith" />
              <span>Zenith</span>
            </div>
          <div className="pre-summit-logo-divider"></div>
          <div className="pre-summit-logo-item">
            {/* <img 
              src="/images/hero/afrexim.png" 
              alt="Afreximbank" 
              className="img-zoom"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span>Afreximbank</span> */}
          </div>
        </div>
      </div>

      {/* ===== MAIN CONTENT ===== */}
      <div className="poster-content">
        {/* ===== HEADER SECTION ===== */}
        <div className="pre-summit-header-section">
          <div className="pre-summit-header-logos">
            <span className="header-brand">ABVIG</span>
            <span className="header-divider">|</span>
            <span className="header-brand">Ministry of Foreign Affairs</span>
            <span className="header-divider">|</span>
            <span className="header-brand">OSGF</span>
          </div>
          <p className="header-tagline">"Driving Africa's Sustainable Future"</p>
        </div>

        {/* Main Heading */}
        <div className="main-heading">
          <div className="heading-line0">AFRICA INFRASTRUCTURE, CLIMATE CHANGE, SECURITY & GREEN INVESTMENT SUMMIT</div>
          <div className="heading-line1">HIGH-LEVEL DIPLOMATIC ROUND TABLE</div>
          <div className="heading-line2">INTER-MINISTERIAL STAKEHOLDERS' ENGAGEMENT FORUM</div>
          <div className="heading-line3">OFFICIAL PREPARATORY FORUM FOR AICIS 2026</div>
        </div>

        {/* Main Title */}
        <div className="main-title">
          <span className="title-aicis">AICIS</span>
          <span className="title-2026">2026</span>
        </div>

        {/* Theme */}
        <div className="global-subtitle">THEME:</div>
        <div className="poster-theme">
          "From Commitments to Implementation: Mobilising Global Finance for Bankable African Projects"
        </div>

        {/* ===== DATE, TIME & VENUE ===== */}
        <div className="pre-summit-datetime-section">
          <div className="datetime-grid">
            <div className="datetime-item">
              <span className="datetime-icon">📅</span>
              <div>
                <h4>Date</h4>
                <p>Tuesday, 15th October 2026</p>
              </div>
            </div>
            <div className="datetime-item">
              <span className="datetime-icon">🕐</span>
              <div>
                <h4>Registration</h4>
                <p>9:00 a.m. – 10:00 a.m.</p>
              </div>
            </div>
            <div className="datetime-item">
              <span className="datetime-icon">⏰</span>
              <div>
                <h4>Forum</h4>
                <p>10:00 a.m. – 1:00 p.m.</p>
              </div>
            </div>
            <div className="datetime-item">
              <span className="datetime-icon">📍</span>
              <div>
                <h4>Venue</h4>
                <p>Rotunda Hall, Ministry of Foreign Affairs, Abuja</p>
              </div>
            </div>
          </div>
        </div>

        {/* ===== HOST & ORGANISER ===== */}
        <div className="pre-summit-host-section">
          <div className="host-grid">
            <div className="host-item">
              <h4>Host</h4>
              <p>Ministry of Foreign Affairs</p>
            </div>
            <div className="host-item">
              <h4>Strategic Collaborator</h4>
              <p>Office of the Secretary to the Government of the Federation (The Presidency)</p>
            </div>
            <div className="host-item">
              <h4>Organiser</h4>
              <p>AICIS 2026 Secretariat</p>
              <p className="host-sub">Africa Business Ventures & Investment Group (ABVIG)</p>
            </div>
          </div>
        </div>

        {/* ===== MAIN WORKSHOP OBJECTIVE ===== */}
        <section className="objective-section-poster">
          <div className="objective-header">
            <span className="objective-badge">MAIN WORKSHOP OBJECTIVE</span>
            <div className="objective-line"></div>
          </div>
          <div className="objective-content">
            <p>
              To create awareness of the Africa Infrastructure, Climate Change, Security & Green Investment Summit (AICIS) 2026 among strategic stakeholders; solicit policy recommendations, strategic partnerships, bankable project pipelines, investment opportunities and financing commitments; and generate inputs to inform the Summit programme, technical sessions, investment agenda, partnership framework and Memoranda of Understanding (MoUs) to be concluded during the <strong>AICIS 2026 Global Summit</strong> scheduled for <strong>25–28 November 2026, Abuja, Nigeria</strong>.
            </p>
          </div>
        </section>

      
        <section className="pre-summit-flier-section" id="flier">
          <div className="pre-summit-flier-container">
            <div className="pre-summit-flier-badge">📄 EVENT FLIER</div>
            <h2 className="pre-summit-flier-title">AICIS 2026 Pre-Summit Round Table</h2>
            <p className="pre-summit-flier-subtitle">
              High-Level Diplomatic Round Table &amp; Inter-Ministerial Stakeholders' Engagement Forum
            </p>
            
            <div className="pre-summit-flier-card">
              <div className="pre-summit-flier-image-wrapper">
                <img 
                  src="/downloads/aicis-2026-flier.jpeg" 
                  alt="AICIS 2026 Pre-Summit Flier"
                  className="pre-summit-flier-image"
                  onClick={() => openFlierModal('/downloads/aicis-2026-flier.jpeg')}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/downloads/aicis-2026-flier.jpeg';
                  }}
                />
              </div>
              
              <div className="pre-summit-flier-details">
                <div className="flier-detail-grid">
                  <div className="flier-detail-item">
                    <span className="flier-detail-icon">📅</span>
                    <div>
                      <h4>Date</h4>
                      <p>Tuesday, 15th October 2026</p>
                    </div>
                  </div>
                  <div className="flier-detail-item">
                    <span className="flier-detail-icon">⏰</span>
                    <div>
                      <h4>Time</h4>
                      <p>10:00 AM Prompt</p>
                    </div>
                  </div>
                  <div className="flier-detail-item">
                    <span className="flier-detail-icon">📍</span>
                    <div>
                      <h4>Venue</h4>
                      <p>Rotunda Hall, Ministry of Foreign Affairs, Abuja</p>
                    </div>
                  </div>
                  <div className="flier-detail-item">
                    <span className="flier-detail-icon">🎤</span>
                    <div>
                      <h4>Theme</h4>
                      <p>From Commitments to Implementation: Mobilising Global Finance for Bankable African Projects</p>
                    </div>
                  </div>
                </div>
                
                <div className="pre-summit-flier-actions">
                  <a 
                    href="/downloads/aicis-2026-flier.jpeg" 
                    download="AICIS-2026-Pre-Summit-Flier.jpeg"
                    className="flier-download-btn"
                  >
                    📥 Download Flier
                  </a>
                  <button onClick={openSignIn} className="flier-signin-btn">
                    Sign In
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== SPEAKERS SECTION ===== */}
        <section className="speakers-section-poster">
          <div className="speakers-header">
            <span className="speakers-badge">KEYNOTE SPEAKERS & MODERATORS</span>
            <h2>Distinguished Speakers</h2>
            <div className="speakers-line"></div>
          </div>

          <div className="speakers-grid-poster">
            {displayedSpeakers.map((speaker) => (
              <div key={speaker.id} className={`speaker-card-poster ${speaker.id === 1 || speaker.id === 2 ? 'featured' : ''}`}>
                <div className="speaker-image-wrapper-poster">
                  <img 
                    src={speaker.image} 
                    alt={speaker.name}
                    className="speaker-image-poster"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.querySelector('.speaker-image-placeholder-poster').style.display = 'flex';
                    }}
                  />
                  <div className="speaker-image-placeholder-poster">
                    <span>👤</span>
                    <p>Add Image</p>
                  </div>
                </div>
                <div className="speaker-badge-poster">{speaker.status}</div>
                <h3 className="speaker-name-poster">{speaker.name}</h3>
                <p className="speaker-title-poster">{speaker.title}</p>
                <p className="speaker-topic-poster">🔹 {speaker.topic}</p>
              </div>
            ))}
          </div>

          {allSpeakers.length > 12 && (
            <div className="speakers-show-more">
              <button onClick={toggleSpeakers} className="show-more-btn">
                {showAllSpeakers ? 'Show Less Speakers' : `Show All ${allSpeakers.length} Speakers`}
              </button>
            </div>
          )}
        </section>

        {/* ===== PROGRAMME OF EVENTS ===== */}
        <section className="programme-section-poster">
          <div className="programme-header">
            <span className="programme-badge">📋 PROGRAMME OF EVENTS</span>
            <div className="programme-line"></div>
          </div>

          {/* REGISTRATION & NETWORKING */}
          <div className="programme-block">
            <h4 className="programme-section-title">REGISTRATION & NETWORKING</h4>
            <div className="programme-table">
              <table>
                <thead>
                  <tr>
                    <th className="col-sn">S/N</th>
                    <th className="col-time">TIME</th>
                    <th className="col-programme">PROGRAMME</th>
                    <th className="col-facilitator">FACILITATOR</th>
                    <th className="col-duration">DURATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>9:00–10:00 a.m.</td>
                    <td>Registration, Accreditation &amp; Networking</td>
                    <td>AICIS Secretariat</td>
                    <td>60 mins</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* OPENING CEREMONY */}
          <div className="programme-block gold-border">
            <div className="programme-section-header">
              <h4 className="programme-section-title">OPENING CEREMONY</h4>
              <p className="programme-section-subtitle">10:00 a.m. – 10:20 a.m.</p>
              <p className="programme-chair"><strong>Chairman of the Event:</strong> H.E. Amb Dr. Dunoma Umar Ahmed, PhD, Permanent Secretary, MFA, Federal Ministry of Foreign Affairs</p>
            </div>
            <div className="programme-table">
              <table>
                <thead>
                  <tr>
                    <th className="col-sn">S/N</th>
                    <th className="col-time">TIME</th>
                    <th className="col-programme">PROGRAMME</th>
                    <th className="col-speaker">SPEAKER</th>
                    <th className="col-duration">DURATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2</td>
                    <td>10:00–10:01</td>
                    <td>Opening by Master of Ceremony</td>
                    <td>Master of Ceremony</td>
                    <td>1 min</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>10:01–10:03</td>
                    <td>National Anthem</td>
                    <td>All Participants</td>
                    <td>2 mins</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>10:03–10:07</td>
                    <td>Opening Remarks &amp; Overview of AICIS 2026</td>
                    <td>Hon. Moses O. T. Owharo, Chairman/CEO, ABVIG &amp; Convener</td>
                    <td>4 mins</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>10:07–10:10</td>
                    <td>Goodwill Message</td>
                    <td>Representative, Office of the Secretary to the Government of the Federation</td>
                    <td>3 mins</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>10:10–10:20</td>
                    <td>Keynote Address</td>
                    <td>Honourable Minister of Foreign Affairs</td>
                    <td>10 mins</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* SESSION I */}
          <div className="programme-block session-block">
            <div className="programme-section-header">
              <h4 className="programme-section-title">SESSION I</h4>
              <p className="programme-section-subtitle">10:20 a.m. – 10:55 a.m.</p>
              <p className="programme-section-theme"><strong>Theme:</strong> Diplomatic Leadership, International Cooperation &amp; Strategic Partnerships</p>
              <div className="programme-chairs-list">
                <p><strong>Chairman:</strong> Ambassador Faruk Malami Yabo, Permanent Secretary, Federal Ministry of Foreign Affairs</p>
                <p><strong>Co-Chairs:</strong> Representative, Embassy of the United States of America • Representative, Federal Ministry of Defence</p>
                <p><strong>Moderator:</strong> Prof. M. T. Ladan</p>
              </div>
            </div>
            <div className="programme-table">
              <table>
                <thead>
                  <tr>
                    <th className="col-sn">S/N</th>
                    <th className="col-time">TIME</th>
                    <th className="col-programme">PRESENTATION</th>
                    <th className="col-speaker">PRESENTER</th>
                    <th className="col-duration">DURATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>7</td>
                    <td>10:20–10:28</td>
                    <td>Diplomatic Perspectives on Global Partnerships</td>
                    <td>Dean of the Diplomatic Corps</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>10:28–10:36</td>
                    <td>U.S.–Africa Strategic Cooperation</td>
                    <td>Representative, U.S. Embassy</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>10:36–10:44</td>
                    <td>EU–Africa Investment &amp; Climate Partnership</td>
                    <td>European Union Delegation</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>10:44–10:49</td>
                    <td>Arab–Africa Economic Cooperation</td>
                    <td>Arab Diplomatic Missions</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>10:49–10:54</td>
                    <td>Asia–Africa Infrastructure Partnerships</td>
                    <td>Asian Diplomatic Missions</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>10:54–10:55</td>
                    <td>Chairman's Summary</td>
                    <td>Chairman</td>
                    <td>1 min</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* SESSION II */}
          <div className="programme-block session-block">
            <div className="programme-section-header">
              <h4 className="programme-section-title">SESSION II</h4>
              <p className="programme-section-subtitle">10:55 a.m. – 11:35 a.m.</p>
              <p className="programme-section-theme"><strong>Theme:</strong> Government Policy, Infrastructure, Climate Action &amp; National Development</p>
              <div className="programme-chairs-list">
                <p><strong>Chair:</strong> Representative, Office of the Secretary to the Government of the Federation</p>
                <p><strong>Moderator:</strong> Prof. Steve Azaiki, Former Member, House of Representatives, Former Member, House Committee on Foreign Affairs</p>
              </div>
            </div>
            <div className="programme-table">
              <table>
                <thead>
                  <tr>
                    <th className="col-sn">S/N</th>
                    <th className="col-time">TIME</th>
                    <th className="col-programme">PRESENTATION</th>
                    <th className="col-speaker">PRESENTER</th>
                    <th className="col-duration">DURATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>13</td>
                    <td>10:55–11:03</td>
                    <td>Parliamentary Diplomacy, Legislative Support &amp; International Partnerships</td>
                    <td>Prof. Steve Azaiki</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>11:03–11:11</td>
                    <td>Climate Governance &amp; National Climate Policy</td>
                    <td>Federal Ministry of Environment / National Council on Climate Change</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>11:11–11:19</td>
                    <td>Financing Infrastructure &amp; Climate Projects</td>
                    <td>Federal Ministry of Finance</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>11:19–11:27</td>
                    <td>Infrastructure Security &amp; National Resilience</td>
                    <td>Federal Ministry of Defence</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>11:27–11:32</td>
                    <td>Legislative Support for Climate Action</td>
                    <td>House Committee on Climate Change</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td>11:32–11:35</td>
                    <td>Moderator's Summary</td>
                    <td>Prof. Steve Azaiki</td>
                    <td>3 mins</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* SESSION III */}
          <div className="programme-block session-block">
            <div className="programme-section-header">
              <h4 className="programme-section-title">SESSION III</h4>
              <p className="programme-section-subtitle">11:35 a.m. – 12:15 p.m.</p>
              <p className="programme-section-theme"><strong>Theme:</strong> Development Finance, Energy Transition &amp; Investment Mobilisation</p>
              <div className="programme-chairs-list">
                <p><strong>Chair:</strong> Representative, African Development Bank</p>
                <p><strong>Co-Chair:</strong> Representative, African Export-Import Bank (Afreximbank)</p>
                <p><strong>Moderator:</strong> Representative, World Bank</p>
              </div>
            </div>
            <div className="programme-table">
              <table>
                <thead>
                  <tr>
                    <th className="col-sn">S/N</th>
                    <th className="col-time">TIME</th>
                    <th className="col-programme">PRESENTATION</th>
                    <th className="col-speaker">PRESENTER</th>
                    <th className="col-duration">DURATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>19</td>
                    <td>11:35–11:43</td>
                    <td>Mobilising Climate Finance for Africa</td>
                    <td>African Development Bank</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td>11:43–11:51</td>
                    <td>Trade &amp; Infrastructure Finance</td>
                    <td>Afreximbank</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>21</td>
                    <td>11:51–11:59</td>
                    <td>Building Investment-Ready Projects</td>
                    <td>World Bank</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>22</td>
                    <td>11:59–12:04</td>
                    <td>Mobilising Sustainable Finance, Green Banking &amp; Infrastructure Investment</td>
                    <td>Zenith Bank Plc</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>23</td>
                    <td>12:04–12:09</td>
                    <td>Innovative Financial Solutions for SMEs, Infrastructure Development &amp; Climate Investment</td>
                    <td>FCMB Group</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>24</td>
                    <td>12:09–12:14</td>
                    <td>Monetary Policy &amp; Investment Stability</td>
                    <td>Central Bank of Nigeria</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>25</td>
                    <td>12:14–12:15</td>
                    <td>Moderator's Summary</td>
                    <td>World Bank</td>
                    <td>1 min</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* SESSION IV */}
          <div className="programme-block session-block">
            <div className="programme-section-header">
              <h4 className="programme-section-title">SESSION IV</h4>
              <p className="programme-section-subtitle">12:15 p.m. – 12:50 p.m.</p>
              <p className="programme-section-theme"><strong>Theme:</strong> Energy Institutions, State Governments &amp; Strategic Partnership Commitments</p>
              <div className="programme-chairs-list">
                <p><strong>Chair:</strong> Hon. Moses O. T. Owharo, Chairman/CEO, ABVIG, Convener, AICIS 2026</p>
                <p><strong>Moderator:</strong> Representative, United Nations Resident Coordinator's Office</p>
              </div>
            </div>
            <div className="programme-table">
              <table>
                <thead>
                  <tr>
                    <th className="col-sn">S/N</th>
                    <th className="col-time">TIME</th>
                    <th className="col-programme">PRESENTATION</th>
                    <th className="col-speaker">PRESENTER</th>
                    <th className="col-duration">DURATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>26</td>
                    <td>12:15–12:20</td>
                    <td>Nigeria's Upstream Investment Opportunities</td>
                    <td>NUPRC</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>27</td>
                    <td>12:20–12:25</td>
                    <td>NNPC Limited Strategic Investment Agenda</td>
                    <td>NNPC Limited</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>28</td>
                    <td>12:25–12:30</td>
                    <td>Petroleum Sector Reforms &amp; Investment</td>
                    <td>Federal Ministry of Petroleum Resources</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>29</td>
                    <td>12:30–12:35</td>
                    <td>Local Content &amp; Industrial Development</td>
                    <td>Nigerian Content Development &amp; Monitoring Board</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>30</td>
                    <td>12:35–12:40</td>
                    <td>UN Support for Sustainable Development &amp; Climate Partnerships</td>
                    <td>Joint Presentation (UNDP, UNICEF &amp; UN System)</td>
                    <td>5 mins</td>
                  </tr>
                  <tr>
                    <td>31</td>
                    <td>12:40–12:48</td>
                    <td>State Governments as Drivers of Bankable Infrastructure, Climate Resilience &amp; Green Investment Projects</td>
                    <td>Representative, Nigeria Governors' Forum (NGF)</td>
                    <td>8 mins</td>
                  </tr>
                  <tr>
                    <td>32</td>
                    <td>12:48–12:50</td>
                    <td>Chair's Summary &amp; Way Forward</td>
                    <td>Hon. Moses O. T. Owharo</td>
                    <td>2 mins</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* CLOSING CEREMONY */}
          <div className="programme-block gold-border">
            <div className="programme-section-header">
              <h4 className="programme-section-title">CLOSING CEREMONY</h4>
              <p className="programme-section-subtitle">12:50 p.m. – 1:00 p.m.</p>
            </div>
            <div className="programme-table">
              <table>
                <thead>
                  <tr>
                    <th className="col-sn">S/N</th>
                    <th className="col-time">TIME</th>
                    <th className="col-programme">PROGRAMME</th>
                    <th className="col-speaker">SPEAKER</th>
                    <th className="col-duration">DURATION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>33</td>
                    <td>12:50–12:53</td>
                    <td>Presentation of Key Outcomes</td>
                    <td>Rapporteur-General</td>
                    <td>3 mins</td>
                  </tr>
                  <tr>
                    <td>34</td>
                    <td>12:53–12:55</td>
                    <td>Adoption of the Abuja Diplomatic Declaration &amp; Workshop Communiqué</td>
                    <td>Chairman of the Event</td>
                    <td>2 mins</td>
                  </tr>
                  <tr>
                    <td>35</td>
                    <td>12:55–12:57</td>
                    <td>Special Announcement – Upcoming AICIS International Events</td>
                    <td>Hon. Moses O. T. Owharo</td>
                    <td>2 mins</td>
                  </tr>
                  <tr>
                    <td>36</td>
                    <td>12:57–12:59</td>
                    <td>Vote of Thanks</td>
                    <td>Representative, AICIS Secretariat / ABVIG</td>
                    <td>2 mins</td>
                  </tr>
                  <tr>
                    <td>37</td>
                    <td>12:59–1:00</td>
                    <td>Closing Remarks</td>
                    <td>H.E. Amb. (Mrs.) Mobalaji S. Ogundero, Technical Adviser – International Cooperation, Federal Ministry of Foreign Affairs</td>
                    <td>1 min</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* SPECIAL ANNOUNCEMENT */}
          <div className="programme-block announcement-block">
            <h4 className="programme-section-title">📢 SPECIAL ANNOUNCEMENT</h4>
            <div className="programme-table">
              <table>
                <thead>
                  <tr>
                    <th className="col-sn">S/N</th>
                    <th className="col-programme">UPCOMING AICIS EVENTS</th>
                    <th className="col-speaker">DATE</th>
                    <th className="col-duration">VENUE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>38</td>
                    <td>AICIS U.S.–Africa Business Week (UNGA 2026)</td>
                    <td>24 September 2026</td>
                    <td>New York, USA</td>
                  </tr>
                  <tr>
                    <td>39</td>
                    <td>Africa Infrastructure, Climate Change, Security &amp; Green Investment Summit (AICIS) 2026 – Global Summit</td>
                    <td>25–28 November 2026</td>
                    <td>Abuja, Nigeria</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* CLOSE OF FORUM */}
          <div className="programme-block close-block">
            <h4 className="programme-section-title">AT THE CLOSE OF THE FORUM</h4>
            <ul className="programme-list">
              <li>📸 Official Group Photograph</li>
              <li>🎤 Joint Media Briefing</li>
              <li>🍽️ Networking Lunch</li>
              <li>🤝 Bilateral Meetings</li>
            </ul>
          </div>

          {/* EXPECTED OUTCOMES */}
          <div className="programme-block outcomes-block">
            <h4 className="programme-section-title">📋 EXPECTED OUTCOMES</h4>
            <div className="outcomes-grid-simple">
              <div className="outcome-item-simple">📜 Abuja Diplomatic Declaration</div>
              <div className="outcome-item-simple">📄 Workshop Communiqué</div>
              <div className="outcome-item-simple">🤝 Strategic Partnership Commitments</div>
              <div className="outcome-item-simple">📊 Bankable Project Pipeline</div>
              <div className="outcome-item-simple">📝 Signing of Strategic Memoranda of Understanding (MoUs)</div>
              <div className="outcome-item-simple">🗺️ Diplomatic Participation Roadmap for AICIS 2026</div>
              <div className="outcome-item-simple">💰 Mobilisation of Global Finance for Africa's Infrastructure, Climate, Security and Green Investment Agenda</div>
            </div>
            <p className="outcomes-theme"><strong>Theme:</strong> "From Commitments to Implementation: Mobilising Global Finance for Bankable African Projects"</p>
          </div>
        </section>

        {/* ===== CONTACT SECTION ===== */}
        <section className="contact-section-poster">
          <div className="contact-header">
            <span className="contact-badge">AICIS 2026 SECRETARIAT</span>
            <div className="contact-line"></div>
          </div>
          <div className="contact-grid">
            <div className="contact-card">
              <h4>Hon. Moses O. T. Owuaro</h4>
              <p>Chairman, Planning & Organising Committee</p>
              <p className="contact-detail">📞 Nigeria: +234 703 294 1519 | +234 814 263 8552</p>
              <p className="contact-detail">📧 info@abvig.com</p>
            </div>
            <div className="contact-card">
              <h4>Office of the Secretary to the Government of the Federation (OSGF)</h4>
              <p><strong>Mr. Kiyawa Aminu</strong></p>
              <p>DD, Political & Economic Affairs</p>
              <p className="contact-detail">📞 +234 806 287 9913</p>
            </div>
            <div className="contact-card">
              <h4>Ministry of Foreign Affairs (MFA)</h4>
              <p><strong>Mr. Abdulqadu Musah</strong></p>
              <p>Review Desk Officer, Economic, Trade & Investment Department (ETID)</p>
              <p className="contact-detail">📞 +234 703 637 6796</p>
              <p><strong>Mr. Ejike Rowland</strong></p>
              <p>Protocol Department</p>
              <p className="contact-detail">📞 +234 803 095 7325</p>
            </div>
          </div>
        </section>

       {/* ===== LINKS & DOWNLOADS SECTION ===== */}
<section className="links-section-poster">
  <div className="links-header">
    <span className="links-badge">📥 DOWNLOADS & LINKS</span>
    <div className="links-line"></div>
  </div>
  
  <div className="links-grid">
    {/* AICIS 2026 Official Website */}
    <div className="link-item">
      <span className="link-icon">🌐</span>
      <a href="https://abvig.com" target="_blank" rel="noopener noreferrer">
        ABVIG Official Website
      </a>
    </div>
  </div>

  {/* Downloads Section */}
  <div className="downloads-grid">
    {/* Event Flier - Image */}
    <div className="download-item">
      <div className="download-icon">🖼️</div>
      <div className="download-info">
        <h4>Event Flier</h4>
        <p>Download the official Pre-Summit flier</p>
      </div>
      <div className="download-buttons">
        <a 
          href="/downloads/aicis-2026-flier.jpeg" 
          download="AICIS-2026-Pre-Summit-Flier.jpg"
          className="download-btn secondary"
        >
          Download JPG
        </a>
      </div>
    </div>

    {/* Programme of Events - Image */}
    <div className="download-item">
      <div className="download-icon">📋</div>
      <div className="download-info">
        <h4>Programme of Events</h4>
        <p>Download the full programme schedule</p>
      </div>
      <div className="download-buttons">
        <a 
          href="/downloads/aicis-2026-programme-of-events.jpeg" 
          download="AICIS-2026-Programme-of-Events.jpg"
          className="download-btn secondary"
        >
          Download JPG
        </a>
      </div>
    </div>

    {/* Brochure - PDF */}
    <div className="download-item featured">
      <div className="download-icon">📘</div>
      <div className="download-info">
        <h4>Brochure</h4>
        <p>Download the AICIS 2026 information brochure</p>
      </div>
      <a 
        href="/brochures/aicis-2026-brochure.pdf" 
        download= "aicis-2026-brochure.pdf"
        className="download-btn primary"
      >
        Download PDF
      </a>
    </div>
  </div>
</section>

        {/* ===== TAGLINE ===== */}
        <div className="tagline-section">
          <p className="tagline-text">🌍 TOGETHER, WE BUILD A SUSTAINABLE, PROSPEROUS AND SECURE AFRICA</p>
        </div>

        {/* ===== BOTTOM LOGOS ===== */}
        <div className="pre-summit-logos-bottom">
          <div className="pre-summit-bottom-logos-container">
            <div className="pre-summit-bottom-logo-item">
              <img src="/images/hero/icad.jpeg" alt="ICAD" />
              <span>ICAD</span>
            </div>
          
            <div className="pre-summit-bottom-logo-divider"></div>
            <div className="pre-summit-bottom-logo-item">
              <img src="/images/hero/fcmb.jpg" alt="FCMB" />
              <span>FCMB</span>
            </div>
            <div className="pre-summit-bottom-logo-divider"></div>
            <div className="pre-summit-bottom-logo-item">
              <img src="/images/hero/afcfta.jpg" alt="AfCFTA" />
              <span>AfCFTA</span>
            </div>
            <div className="pre-summit-bottom-logo-divider"></div>
            <div className="pre-summit-bottom-logo-item">
              <img src="/images/hero/undp.jpg" alt="UNDP" />
              <span>UNDP</span>
            </div>
            <div className="pre-summit-bottom-logo-divider"></div>
            <div className="pre-summit-bottom-logo-item">
              <img src="/images/hero/sdg.png" alt="SDG" />
              <span>SDG</span>
            </div>
          </div>
        </div>

        {/* ===== BOTTOM GALLERY ===== */}
        <div className="bottom-gallery">
          <div className="wave-top"></div>
          <div className="gallery-strip">
            <div className="gallery-item">
              <img src={galleryImages.climate} alt="Climate Change" />
              <div className="gallery-label">Climate Action</div>
            </div>
            <div className="gallery-item">
              <img src={galleryImages.rainforest} alt="Rainforest" />
              <div className="gallery-label">Rainforest</div>
            </div>
            <div className="gallery-item">
              <img src={galleryImages.solar} alt="Renewable Energy" />
              <div className="gallery-label">Renewable Energy</div>
            </div>
            <div className="gallery-item">
              <img src={galleryImages.agriculture} alt="Smart Agriculture" />
              <div className="gallery-label">Smart Agriculture</div>
            </div>
            <div className="gallery-item">
              <img src={galleryImages.train} alt="Modern Infrastructure" />
              <div className="gallery-label">Infrastructure</div>
            </div>
          </div>
          <div className="wave-bottom"></div>
        </div>

        {/* ===== BACK & SIGN IN BUTTONS ===== */}
        <div className="detail-back">
          <Link to="/events" className="back-button">
            ← Back to Events
          </Link>
          <button onClick={openSignIn} className="signin-button">
            Sign In
          </button>
        </div>

        {/* ===== REGISTER BUTTON ===== */}
        <div className="pre-summit-register-bottom">
          <div className="register-bottom-content">
            <h3>Ready to Join the Summit?</h3>
            <p>Register now to secure your spot at the AICIS 2026 Global Summit</p>
            <Link to="/register" className="register-bottom-btn">
              Register Now →
            </Link>
          </div>
        </div>

        {/* ===== SIGN IN MODAL ===== */}
        <SignInModal isOpen={isSignInOpen} onClose={closeSignIn} />

        {/* ===== FLIER ENLARGE MODAL ===== */}
        {selectedFlier && (
          <div className="flier-modal-overlay" onClick={closeFlierModal}>
            <div className="flier-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="flier-modal-close" onClick={closeFlierModal}>×</button>
              <img 
                src={selectedFlier} 
                alt="AICIS 2026 Pre-Summit Flier Full View" 
                className="flier-modal-image" 
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/downloads/aicis-2026-flier.jpeg';
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreSummit;